export default "__VITE_ASSET__BNMnv16X__"